import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import TopNavigation from './TopNavigation';

const Header = ({branchInfo, shorHeader = false}) => {
  return (
    <>
      <header className="header shop-header">

        <TopNavigation shorHeader={ shorHeader } />

      </header>
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    branchInfo
  } = state;

  return {
    branchInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Header);
